export default {"src":"/_next/static/media/phone-booth.175aa137.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};